module.exports = __webpack_public_path__ + "img/upload_zodiac_3.7e8d90ff.webp";